import dayjs from 'dayjs'

/**
 * 深拷贝
 * ----------------------------------------------------
 */
export const keepCloning = (obj) => {
    var str, newobj = obj.constructor === Array ? [] : {};
    if (typeof obj !== 'object') {
        return;

    } else if (window.JSON) {
        // newobj = JSON.parse(JSON.stringify(obj))
        str = JSON.stringify(obj), //系列化对象
            newobj = JSON.parse(str); //还原

    } else {
        for (var i in obj) {
            // 判断ojb子元素是否为对象，如果是，递归复制
            newobj[i] = typeof obj[i] === 'object' ?
                cloneObj(obj[i]) : obj[i];
        }
    }
    return newobj;
}
export const dateFilter = (value) => {
    return dayjs(value)
}

/**
 * 格式化时间戳（秒|毫秒）
 * -------------------------------------------------
 */
export const timeFilter = (value) => {
    value = value.toString();
    if (value) {
        if (value.length === 13) {
            return dayjs(Number(value)).format("YYYY-MM-DD HH:mm:ss");
        }
        return dayjs.unix(Number(value)).format("YYYY-MM-DD HH:mm:ss");
    } else {
        return '-';
    }
}

/**
 * 手机号格式化
 * ------------------------------------------------
 */
export const formatPhone = (phone) => {
    phone = phone.toString();
    return phone.substr(0, 3) + '****' + phone.substr(7, 11);
};

/**
 * 4位一空格（格式化银行卡）
 * -----------------------------------------------
 */
export const formatBank = (val) => {
    if (val) {
        return val.toString().replace(/\s/g, '').replace(/(.{4})/g, "$1 ");
    }
};

/**
 * 千分位格式化
 * ----------------------------------------------
 */
export const toThousands = (val) => {
    let num = (val || 0).toString(),
        result = '';
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return result;
}

/**
 * 格式化小数位
 * -------------------------------------------
 */
export const formatFloat = (val, pos = 2) => {
    let f = parseFloat(val);
    if (isNaN(f)) {
        return false;
    }
    f = Math.round(val * Math.pow(10, pos)) / Math.pow(10, pos); // pow 幂
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + pos) {
        s += '0';
    }
    return s;
}

/**
 * 格式化时长
 * --------------------------------------------------
 */
export const realFormatSecond = (second) => {
    let secondType = typeof second;

    if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second);

        let hours = Math.floor(second / 3600);
        second = second - hours * 3600;
        let mimute = Math.floor(second / 60);
        second = second - mimute * 60;

        return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
        return '0:00:00'
    }
};

/**
 *  数组对象去重
 *  --------------------------------------------
 */
export const mapFilter = (arr) => {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1))
};

/**
 * 时间转换
 * ---------------------------------------------
 */
export const getDate = (str_time) => {
    var re = new RegExp('\\/Date\\(([-+])?(\\d+)(?:[+-]\\d{4})?\\)\\/');
    var r = (str_time || '').match(re);
    var format = r ? new Date(((r[1] || '') + r[2]) * 1) : null;
    return r ? new Date(((r[1] || '') + r[2]) * 1) : null;
}

export const formatDate = (now) => {
    var year = now.getYear() + 1900;
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

/**
 * 数组
 * ---------------------------------------------
 */
export const unshiftArr = (arr) => {
    return Array.prototype.unshift.bind(null, arr)
}

/**
 * 日期转换年月日
 * ---------------------------------------------
 */

export const getFormatDate = () => {
    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1;
    var curr_year = d.getFullYear();
    String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
    String(curr_date).length < 2 ? (curr_date = "0" + curr_date) : curr_date;
    var yyyyMMdd = curr_year + "-" + curr_month + "-" + curr_date;
    return yyyyMMdd;
}

/**
 * 
 * 日期转换
 */

export const timeTransform = (date) => {

    return formatDate(getDate(date));


}
/**
 * guid
 * ---------------------------------------------
 */

export const guid = () => {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

// 

export const FromatDataTime = (now) => {

    var year = now.getFullYear();       //年
    var month = now.getMonth() + 1;     //月
    var day = now.getDate();            //日

    var hh = now.getHours();            //时
    var mm = now.getMinutes();          //分

    var clock = year + "-";
    if (month < 10)
        clock += "0";
    clock += month + "-";
    if (day < 10)
        clock += "0";
    clock += day + " ";
    if (hh < 10)
        clock += "0";
    clock += hh + ":";
    if (mm < 10) clock += '0';
    clock += mm;
    clock += ":00"
    return (clock);

}


// 周日期生成
export const GenerateWeek = (year, month, day, number) => {
    let date = year + '-' + month + '-' + day
    var dateTime = new Date(date);
    dateTime = dateTime.setDate(dateTime.getDate() + number);
    dateTime = new Date(dateTime);
    return FromatDataTime(dateTime).split(' ')[0]

}

export const isIntNum = (val) => {
    var regPos = / ^\d+$/; // 非负整数 
    var regNeg = /^\-[1-9][0-9]*$/; // 负整数
    if (regPos.test(val) && regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}

export const isIdCard = (idCard) => {
    var flag = false;
    //15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
            var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
            for (var i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }

            var idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
            var idCardLast = idCard.substring(17);//得到最后一位身份证号码

            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == "X" || idCardLast == "x") {
                    flag = true;
                } else {
                    flag = false;
                }
            } else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    flag = true;
                } else {
                    flag = false;
                }
            }
        } else if (idCard.length == 15) {
            var id17 = idCard.substring(0, 6) + '19' + idCard.substring(6);
            var parityBit = getParityBit(id17);
            var tempIdCard = id17 + parityBit;
            flag = validateIdCard(tempIdCard);
        }
    } else {
        flag = false;
    }
    return flag;
}

export const isPhone = (val) => {
    return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(val);
};




/**
 * 名字脱敏 保留首位
 * @param fullName
 * @returns {string}
 */
export const desensitizedName = (fullName) => {
    if (!fullName) {
        return "";
    }

    let str = fullName.substr(0, 1);
    for (let i = 0; i < fullName.length - 1; i++) {
        str += '*';
    }

    return str;
}

/**
 * 脱敏公用
 * @param str 脱敏字符串
 * @param begin 起始保留长度，从0开始
 * @param end 结束保留长度，到str.length结束
 * @returns {string}
 */
export const desensitizedCommon = (str, begin, end) => {
    if (!str && (begin + end) >= str.length) {
        return "";
    }

    let leftStr = str.substring(0, begin);
    let rightStr = str.substring(str.length - end, str.length);

    let strCon = ''
    for (let i = 0; i < str.length - end - begin; i++) {
        strCon += '*';
    }
    return leftStr + strCon + rightStr;
}

/**
 * 手机号脱敏
 * @param str
 * @returns {string|*|string}
 */
export const desensitizedPhone = (str) => {
    if (!str) {
        return "";
    }
    return str.replace(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{4}(\d{4})$/, '$1****$2');
}

/**
 * 身份证号脱敏
 * @param str
 * @returns {string|*|string}
 */
export const desensitizedIdNo = (str) => {
    if (!str) {
        return "";
    }
    if (/(\d{6})(\d*)(\w{3})/.test(str)) {
        let text1 = RegExp.$1;
        let text3 = RegExp.$3;
        let text2 = RegExp.$2.replace(/./g, "*");
        return text1 + text2 + text3;
    }
    return str;
}

/**
 * 地址脱敏
 * @param str
 * @returns {string|*|string}
 */
export const desensitizedAddr = (str) => {
    if (!str) {
        return "";
    }
    if (/(.{9})(.*)/.test(str)) {
        let text1 = RegExp.$1;
        let text2 = RegExp.$2.replace(/./g, "*");
        return text1 + text2;
    }
    return str;
}
